var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"dailyOverview nowrap ws-normal-ns\noverflow-x-auto flex flex-column-ns list pa3 mt4 mt2-ns mb0"},_vm._l((_vm.hours),function(hour){return _c('DailyOverviewItem',{key:hour.time,attrs:{"hourInfo":hour}})}))}
var staticRenderFns = []

export { render, staticRenderFns }